/**
 * The ASG corporate identity, transcribed from the ONE governed declaration:
 * `infrastructure/playbooks/globals/branding.yml` in the lean-governance repo
 * (itself a transcription of the `asg-corporate-identity` skill's
 * assets/tokens/asg-colors.json v1.0.0).
 *
 * Keep these values byte-identical to that file. It is the source of truth and
 * is guarded there by `infrastructure/tests/brand-parity/`; this copy exists
 * only because the portal image is built from a separate repository, which the
 * guard cannot read.
 */
export const asg = {
  // Brand
  navy: '#15284B', // primary: headings, primary UI, dark surfaces
  navy700: '#1B2C42', // alternate dark surface / gradient pair with navy
  orange: '#E24402', // accent: CTAs, links, highlights. Sparingly.
  green: '#00956D', // secondary: success, supporting accents
  // Neutrals
  ink: '#15284B', // heading text (aliases navy, deliberately)
  body: '#2A2F3A', // body copy on light backgrounds
  muted: '#5C6470', // captions, secondary text
  border: '#E1E5EC', // hairlines, dividers, table borders
  surface: '#F7F8FA', // off-white sections, zebra rows
  white: '#FFFFFF',
  onNavyMuted: '#C9D2E0', // subtitle/footer text on a navy ground
  // State
  warning: '#FFC000',
  danger: '#D7263D',
  // Type
  fontHeading: "'Montserrat', 'Segoe UI', Calibri, Arial, sans-serif",
  fontBody: "'Inter', 'Segoe UI', Calibri, Arial, sans-serif",
  // Shape
  radiusSm: 4,
  radiusMd: 8,
  radiusLg: 16,
  radiusPill: 999,
  shadowCard: '0 2px 8px rgba(21, 40, 75, 0.08)',
  shadowRaised: '0 8px 24px rgba(21, 40, 75, 0.12)',
} as const;
